import cn from 'classnames';
import styles from './ModalFullScreen.module.scss';
import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';

type ModalFullScreenProps = {
  className?: string;
  children: ReactNode;
  opened: boolean;
  closeFn: () => void;
};

export function ModalFullScreen({
  className,
  children,
  opened,
  closeFn,
}: ModalFullScreenProps) {
  const wrapperClassName = cn(styles.container, className);
  useBodyScrollLock(opened);

  if (!opened) return null;

  return createPortal(
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <div className={styles.heading}>
          <div />
          <img
            src="/svg/close.svg"
            alt="close"
            className={styles.close}
            onClick={closeFn}
          />
        </div>
        {children}
      </div>
    </div>,
    document.body,
  );
}
